module.exports = __webpack_public_path__ + "media/custom/images/img24-d65e9ff621eb4bc2e4bd5bf7da57c3c0.jpg";